{
  "level": "mt02gmv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02gmv",
    "objects": "AREAS.E3:mt02gmv.e3",
    "mesh": "TREES.E3:mt02gmv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: bridelev",
      "entity_class": "CSlidingDoor",
      "piece_name": "bridelev",
      "offset": 4038,
      "centroid": [
        -1617.25,
        -3434.0,
        1438.75
      ],
      "bbox_min": [
        -1624.5,
        -3441.5,
        1438.5
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1439.0
      ],
      "dimensions_source": {
        "span_x": 14.5,
        "span_y": 15.0,
        "height_z": 0.5,
        "door_width": 15.0,
        "door_depth": 14.5,
        "leaf_depth": 14.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -1624.5,
          -3441.5,
          1438.5
        ],
        [
          -1624.5,
          -3426.5,
          1439.0
        ],
        [
          -1624.5,
          -3441.5,
          1439.0
        ],
        [
          -1624.5,
          -3426.5,
          1438.5
        ],
        [
          -1610.0,
          -3441.5,
          1438.5
        ],
        [
          -1610.0,
          -3426.5,
          1439.0
        ],
        [
          -1610.0,
          -3441.5,
          1439.0
        ],
        [
          -1610.0,
          -3426.5,
          1438.5
        ]
      ],
      "plane_distance": -1439.0,
      "authentic_texture": "spkelevfloor1"
    }
  ],
  "tutorial_messages": []
}